import React from 'react'
import { UpArrowIcon, DownArrowIcon } from '@ow/icons'
import { SelectComponents as components } from './index'

const { DropdownIndicator } = components

export const CustomDropdownIndicator = (props) => {
  const {
    selectProps: { menuIsOpen },
  } = props

  return (
    <DropdownIndicator {...props}>
      {menuIsOpen ? <UpArrowIcon /> : <DownArrowIcon />}
    </DropdownIndicator>
  )
}
